var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderhistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 3.3335H5.83335C4.91288 3.3335 4.16669 4.07969 4.16669 5.00016V15.8335C4.16669 16.754 4.91288 17.5002 5.83335 17.5002H14.1667C15.0872 17.5002 15.8334 16.754 15.8334 15.8335V5.00016C15.8334 4.07969 15.0872 3.3335 14.1667 3.3335Z",
    stroke: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H12.5M7.5 10.8333H12.5M7.5 14.1667H10.8333",
    stroke: "#2B2B2B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderhistory);
export default __webpack_public_path__ + "static/media/orderhistory.1b290526f296dc5c3d327971d7af258b.svg";
export { ForwardRef as ReactComponent };